import { data } from "../../constants";

export const onUpdateApplicantStatus = (
  applicant: any,
  updatedStatus: string,
  setApplicantName: Function,
  setShowModal: Function,
  _updateStatusFunc: any,
  isJobOffer?: boolean
) => {
  const negativeScenarios = [
    data.applicationStatus[2],
    data.applicationStatus[3],
    data.applicationStatus[4],
  ];

  if (
    negativeScenarios.includes(updatedStatus) &&
    !isJobOffer &&
    (updatedStatus !== "No Show" || "No Response")
  ) {
    setApplicantName(applicant.fullName);
    return setShowModal(true);
  }
  return _updateStatusFunc(applicant, updatedStatus);
};
